// extracted by mini-css-extract-plugin
module.exports = {"fillBlack":"slopesColors_fillBlack__zOkge","fillGreen":"slopesColors_fillGreen__S9Oo_","fillRed":"slopesColors_fillRed__UWlbq","fillPrimary":"slopesColors_fillPrimary__gbM06"};